import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import InstrumentIcon from "../../../../components/instrument-icon";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form-button";
import Big from "big.js";
import {useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import associateServices from "../../../../services";
import InputMask from "react-input-mask";
import MATH_HELPER from "../../../../helpers/math-helper";
import InformationToast from "../../../../components/toast/InformationToast";
import WithdrawCurrencyDropdown from "./currency-dropdown";
import NetworkDropdown from "../network-dropdown";
import TryPaymentMethodDropdown from "../withdraw/try-withdraw/method-dropdown";
import TryWithdraw from "./try-withdraw/try-withdraw";
import {decrypt, encrypt} from "../../../../helpers/encryption";
import WithdrawDepositToast from "../../../../components/toast/WithdrawToast";
import store from "../../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../../actions/authentication-actions";
import TryMethodsModal from "../deposit/try-deposit/try-methods-modal";
import TryProvidersModal from "../deposit/try-deposit/try-providers-modal";
import AznPaymentMethodDropdown from "./azn-withdraw/method-dropdown";
import AznWithdraw from "./azn-withdraw/azn-withdraw";

const WithdrawModal = props => {
    const {
        selectedWallet,
        currencyList,
        currencies,
        selectedFiat,
        networkSettings
    } = useSelector(state => state.authenticationReducer)

    const {
        modalCurrency,
    } = useSelector(state => state.globalReducer)

    const [networks, setNetworks] = useState([])
    const [rates, setRates] = useState({})
    const [tryPaymentMethod, setTryPaymentMethod] = useState('')
    const [method, setMethod] = useState({})
    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const {t} = useTranslation()
    const [selectedCurrency, setSelectedCurrency] = useState({})
    const [theNetwork, setTheNetwork] = useState("")
    const [_, setSearchParams] = useSearchParams()
    const [step, setStep] = useState('form')

    const [instance, setInstance] = useState({
        address: '',
        amount: '',
        otp: '',
    })

    const handleReset = () => {
        setStep('form')
        handleChange('otp', '')
    }


    useEffect(() => {
        if (modalCurrency) {
            const theWalletMe = currencyList.find(i => i.code === modalCurrency)
            setSelectedCurrency(theWalletMe)

        } else if (selectedWallet?.code) {
            const theWalletMe = currencyList.find(i => i.code === selectedWallet?.code)
            setSelectedCurrency(theWalletMe)
        }
    }, [selectedWallet, modalCurrency])

    useEffect(() => {
        setDisabled(instance?.address === '' || instance?.amount === '')
    }, [instance?.address, instance?.amount])

    const [isNetworkDisabled, setIsNetworkDisabled] = useState(false)
    useEffect(() => {


        if (selectedCurrency?.code && theNetwork) {
            const item = networkSettings?.find(oo => oo.currency === selectedCurrency?.code && oo?.network?.key === theNetwork)

            setIsNetworkDisabled(!item || !item?.is_withdraw)
        }
    }, [networkSettings, selectedCurrency, theNetwork])

    const handleWithdraw = () => {
        if (loading)
            return false;

        let amount = instance.amount
        if (selectedFiat)
            amount = Big(instance.amount || 0).times(rates[selectedCurrency?.code] || 0).toFixed(8)


        const body = {
            ...instance,
            code: selectedCurrency.code,
            network: theNetwork,
            amount
        }
        body.amount = body?.amount?.replace(/,/g, '.')

        if (!MATH_HELPER.isNumeric(body.amount))
            return toast.error(t(`general.enter-a-valid-amount`))


        setLoading(true)

        associateServices.withdraw(body).then(res => {

            setLoading(false)

            if (res?.status !== 200) {
                return toast(<InformationToast
                    icon={'ti-error-404'}
                    title={'...'}
                    message={t(`api-notifications.${res?.errors}`)}
                />)
            }

            if (step === 'form') {
                if (res?.data?.step === 'email' || res?.data?.step === '2factor') {
                    setStep(res?.data?.step || '')
                    handleChange('secret', res?.data?.secret)
                }
            } else {

                const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))

                associateServices.getWallets({}).then(handleUserWallets)


                if (res?.data === 'withdraw-request-submitted')
                    toast(<WithdrawDepositToast
                        amount={amount}
                        code={selectedCurrency?.code}
                        title={t(`api-notifications.${res.data}`)}
                    />)

                handleReset()
            }
        })


    }
    const [regex] = useState(new RegExp("^\\d{1,8}(\\.\\d{0," + 8 + "})?$"))

    const handleChange = (type, value) => {
        if (type === 'amount') {
            if (value === '' || regex.test(value)) {
                setInstance(prevState => ({
                    ...prevState,
                    [type]: value
                }))
            }
        } else
            setInstance(prevState => ({
                ...prevState,
                [type]: value
            }))
    }


    useEffect(() => {
        const instances = currencies?.filter(currency => currency.alias === selectedCurrency?.code)

        if (instances.length === 1) {
            // 1 network setTheNetwork
            setTheNetwork(instances[0].network.key)
            setNetworks(instances?.map(currency => ({
                name: currency.network.name,
                key: currency.network.key,
            })))
        } else if (instances.length >= 2) {

            setTheNetwork(instances[0].network.key)
            setNetworks(instances?.map(currency => ({
                name: currency.network.name,
                key: currency.network.key,
            })))
        }
    }, [selectedCurrency?.code, currencies])

    const handleChangeWallet = wall => {

        if (wall.code === selectedCurrency?.code)
            return true

        setTheNetwork('')
        setSearchParams({
            modal: 'wallet',
            tab: 'withdraw',
            currency: wall.code,
        })

        const instances = currencies?.filter(ioi => ioi.alias === wall?.code)

        if (instances)
            setSelectedCurrency(wall)

    }

    const handleSelectNetwork = nett => {
        setTheNetwork(nett?.key)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter')
            handleWithdraw()
    }


    const [minAmount, setMinAmount] = useState('')

    useEffect(() => {

        if (selectedCurrency?.code)
            associateServices.getMinWithdrawAmount({
                code: selectedCurrency?.code
            }).then(res => {
                setMinAmount(res?.data || null)
            })
    }, [selectedCurrency?.code])

    useEffect(() => {

        if (selectedFiat) {

            console.log('selectedFiat = ', selectedFiat)
            const handleFiatRates = e => {
                const data = decrypt(e)

                console.log('rates - ', rates)
                setRates(data)
            }
            window?.tcpSocket?.emit('fiat:rate', encrypt({
                currency: selectedFiat
            }))

            window?.tcpSocket?.on('fiat:rates', handleFiatRates)


        }

    }, [selectedFiat])

    const getDisplayCurrency = () => {
        if (!selectedFiat)
            return `${Big(instance?.amount || 0).toFixed(8)} ${selectedCurrency?.code}`

        return `${Big(instance.amount || 0).times(rates[selectedCurrency?.code] || 0).toFixed(8)} ${selectedCurrency?.code}`
    }

    const handleSetMax = () => {
        console.log('selectedCurrency = ', selectedCurrency)
        if (!selectedFiat)
            return handleChange('amount', Big(selectedCurrency?.balance || 0).toFixed(8))

        return handleChange('amount', Big(selectedCurrency.balance || 0).div(rates[selectedCurrency?.code] || 0).toFixed(2))


    }
    return (

        <>


            {
                step === 'form' ?
                    <>
                        <div className="modal__drops">

                            <WithdrawCurrencyDropdown currencyList={currencyList}
                                                      handleChangeWallet={handleChangeWallet}
                                                      selectedCurrency={selectedCurrency}/>

                            {
                                selectedCurrency?.code === 'TRY' ?
                                    <TryPaymentMethodDropdown
                                        method={'withdraw'}
                                        tryPaymentMethod={tryPaymentMethod}
                                        setMethod={setMethod}
                                        setTryPaymentMethod={setTryPaymentMethod}/>
                                    :
                                    selectedCurrency?.code === 'AZN' ?
                                        <AznPaymentMethodDropdown
                                            method={'withdraw'}
                                            tryPaymentMethod={tryPaymentMethod}
                                            setMethod={setMethod}
                                            setTryPaymentMethod={setTryPaymentMethod}/>
                                        :
                                    <NetworkDropdown theNetwork={theNetwork} networks={networks}
                                                     handleSelectNetwork={handleSelectNetwork}/>

                            }
                        </div>

                        {
                            selectedCurrency?.code === 'TRY' ? <TryWithdraw method={method} type={tryPaymentMethod}/> :
                            selectedCurrency?.code === 'AZN' ? <AznWithdraw method={method} type={tryPaymentMethod}/> :
                                isNetworkDisabled ?
                                    <div className="form__group">
                                        <p className="form__note error text-align mt-5 mb-5">
                                            {t('modals.wallet.withdraw.withdraw-disabled', {
                                                network: theNetwork,
                                                currency: selectedCurrency.code
                                            })}
                                        </p>
                                    </div>
                                    :
                                    <div className="modal__form">
                                        <div className="form__group">
                                            <label htmlFor="" className="form__label">
                                                {t('modals.wallet.withdraw.code-address', {
                                                    code: selectedCurrency?.code
                                                })} <b>*</b>
                                            </label>
                                            <input
                                                value={instance.address}
                                                onChange={e => handleChange('address', e.target.value)}
                                                type="text" className="form__input"/>
                                        </div>
                                        <div className="form__group">
                                            <label htmlFor="" className="form__label form__label--max">
                                                {t('modals.wallet.withdraw.amount')} <b>*</b>
                                                <span>
                                                    {getDisplayCurrency()}
                                            </span>
                                            </label>
                                            <div className="form__amount">
                                                <input
                                                    inputMode="decimal"
                                                    pattern="[0-9]*[.,]?[0-9]*"

                                                    value={instance.amount}
                                                    onChange={e => handleChange('amount', e.target.value)}
                                                    type="text" className="form__input"/>

                                                <div className="form__coin">
                                                    <InstrumentIcon code={selectedFiat || selectedCurrency?.code}/>
                                                </div>
                                                <button className="form__max" type="button"

                                                        onClick={handleSetMax}>
                                                    {t('modals.wallet.withdraw.max')}
                                                </button>
                                            </div>
                                        </div>


                                        <FormButton onClick={handleWithdraw}
                                                    label={t('modals.wallet.withdraw.withdraw')}
                                                    disabled={loading || disabled}
                                                    loading={loading}
                                        />


                                        {
                                            minAmount &&
                                            <p className="form__description">
                                                {t('modals.wallet.withdraw.min-amount-desc', {
                                                    amount: Big(minAmount || 0).toFixed(8),
                                                    code: selectedCurrency?.code
                                                })}
                                            </p>
                                        }

                                    </div>
                        }
                    </>

                    :


                    !['TRY', 'AZN']?.includes(selectedCurrency?.code) &&
                    <>
                        {/*// OTP CODE*/}
                        <div className="form__group">
                            <label htmlFor="" className="form__label form__label--max med">
                                {t('tip.amount')} <b>*</b>
                                <span className="d-flex align-items-center gap-2">
                                    <InstrumentIcon code={selectedCurrency?.code}/>
                                    {Big(instance?.amount || 0).toFixed(8)}
                                    </span>
                            </label>

                        </div>
                        <div className="form__group">
                            <label htmlFor="" className="form__label">
                                {t(`general.enter-otp-code-${step}`)} <b>*</b>
                            </label>
                            <InputMask
                                onKeyDown={handleKeyDown}
                                mask={'999999'}
                                maskPlaceholder={null}
                                disabled={step === 'form'}
                                className="form__input"
                                value={instance.otp || ''}
                                onChange={e => handleChange('otp', e.target.value)}
                                type="text" // Set type to text
                                inputMode="numeric" // Hint for numeric keyboard
                            />
                        </div>

                        <FormButton onClick={handleWithdraw}
                                    label={t('modals.wallet.withdraw.withdraw')}
                                    disabled={loading || disabled || instance.otp?.length !== 6}
                                    loading={loading}
                        />


                    </>

            }

        </>
    )

}


export default WithdrawModal
